import React from "react";
import {
  PieChart,
  Clock,
  Users,
  Tag,
  CheckCircle2,
  ArrowUpRight,
} from "lucide-react";
import Abuse1 from "../../../../assets/svg/wallet 1.svg";
import Abuse2 from "../../../../assets/svg/Vector (7).svg";
import Abuse4 from "../../../../assets/svg/pie-chart 1.svg";
import "./OverviewTab.css";

const basicInfo = {
  couponCode: "SUMMER20",
  couponType: "Percentage Discount",
  discountValue: "20%",
  status: "Active",
  maxDiscount: "500 EGP",
  minOrderValue: "1,500 EGP",
  usageLimit: "5,000 Redemptions",
  perCustomerLimit: "1 Redemption",
};

const budgetUsage = {
  totalBudget: "1,000,000 EGP",
  usedBudget: "249,600 EGP",
  remainingBudget: "750,400 EGP",
  redemptions: "1,248 / 5,000",
  usedPercent: 25, // نسبة الشريط الملون
};

const eligibility = {
  assignmentType: "Segment-Based",
  assignedTo: "VIP Customers",
  distributionChannel: "Mobile App + Admin Assignment",
  usedBy: "3,200 users",
  assignedBy: "Mona Salah",
  assignmentDate: "Mar 10, 2025",
};

const validity = {
  startDate: "Mar 10, 2025",
  endDate: "May 31, 2025",
  daysRemaining: "13 days left",
  autoExpiry: "Enabled",
  expiryBehavior: "Automatically deactivate",
};

const rulesSafeguards = {
  stackBehavior: "Non-Stackable",
  partialRedemption: "Allowed",
  restoreOnCancel: "Enabled",
  fraudRisk: "Low",
  applicableChannels: "Mobile App , Call Center",
  usageLimit: "One per eligible user",
  excludedItems: "Taxes, Doorstep Fee",
};

const fundingLiability = {
  fundingSource: "ESTBN",
  providerShare: "0%",
  estbnShare: "100%",
  totalCommittedValue: "500,000 EGP",
  totalDiscountGiven: "168,000 EGP",
  remainingCommitment: "332,000 EGP",
};

const performanceSnapshot = [
  {
    icon: Abuse1,
    
    label: "Total Redemptions",
    value: "1,248",
  },
  { icon: Abuse2,  label: "Avg Discount", value: "200 EGP" },
  {
    icon: Abuse2,
    
    label: "Avg Order Value",
    value: "1,000 EGP",
  },
  { icon: Abuse4,  label: "Discount Rate", value: "20%" },
];

const quickInsights = [
  { icon: Abuse1, label: "27 days remaining" },
  { icon: Abuse2, label: "High VIP usage" },
  { icon: Abuse2, label: "Avg discount 200 EGP" },
  { icon: Abuse4, label: "Budget utilization 24.96%" },
];

const recentActivity = [
  {
    title: "Coupon details updated",
    date: "May 18, 2025 - 02:30 pm",
    by: "Ahmed Hassan",
  },
  {
    title: "Coupon assigned",
    date: "May 16, 2025 - 11:45 am",
    by: "Mona Salah",
  },
  { title: "Threshold updated", date: "May 14, 2025 - 09:20 am", by: "System" },
  { title: "Threshold updated", date: "May 14, 2025 - 09:20 am", by: "System" },
  {
    title: "Coupon activated",
    date: "May 12, 2025 - 04:15 pm",
    by: "Ahmed Hassan",
  },
  {
    title: "Coupon activated",
    date: "May 12, 2025 - 04:15 pm",
    by: "Ahmed Hassan",
  },
  {
    title: "Coupon exported",
    date: "May 11, 2025 - 03:10 pm",
    by: "Mona Salah",
  },
];

// كومبوننت صغير لكل Field (label فوق + value تحت)
function Field({ label, value, valueClass = "" }) {
  return (
    <div className="ov-field">
      <span className="ov-field-label">{label}</span>
      <span className={`ov-field-value ${valueClass}`}>{value}</span>
    </div>
  );
}

// كومبوننت العنوان بتاع كل Section (دايرة رقم + عنوان)
function SectionTitle({ number, title }) {
  return (
    <div className="ov-section-title">
      <span className="ov-section-number">{number}</span>
      <h3>{title}</h3>
    </div>
  );
}

export default function OverviewTab() {
  return (
    <div className="ov-grid">
      {/* ================= LEFT COLUMN ================= */}
      <div className="ov-left-col">
        <div className="ov-card">
          <SectionTitle number={1} title="Basic Information" />
          <div className="ov-fields-row">
            <Field label="Coupon Code" value={basicInfo.couponCode} />
            <Field label="Coupon Type" value={basicInfo.couponType} />
            <Field label="Discount Value" value={basicInfo.discountValue} />
            <Field
              label="Status"
              value={
                <span className="ov-status-value">
                  <span className="ov-status-dot" /> {basicInfo.status}
                </span>
              }
            />
          </div>
          <div className="ov-fields-row">
            <Field label="Maximum Discount" value={basicInfo.maxDiscount} />
            <Field
              label="Minimum Order Value"
              value={basicInfo.minOrderValue}
            />
            <Field label="Usage Limit" value={basicInfo.usageLimit} />
            <Field
              label="Per Customer Limit"
              value={basicInfo.perCustomerLimit}
            />
          </div>

          <hr className="ov-divider" />

          <SectionTitle number={2} title="Budget & Usage" />
          <div className="ov-fields-row">
            <Field label="Total Budget" value={budgetUsage.totalBudget} />
            <Field label="Used Budget" value={budgetUsage.usedBudget} />
            <Field
              label="Remaining Budget"
              value={budgetUsage.remainingBudget}
            />
            <Field label="Redemptions" value={budgetUsage.redemptions} />
          </div>

          <div className="ov-progress-bar">
            <div
              className="ov-progress-fill"
              style={{ width: `${budgetUsage.usedPercent}%` }}
            />
          </div>
          <div className="ov-progress-legend">
            <span>
              <i className="ov-dot ov-dot-teal" /> Used Budget (
              {budgetUsage.usedBudget})
            </span>
            <span>
              <i className="ov-dot ov-dot-gray" /> Remaining Budget (
              {budgetUsage.remainingBudget})
            </span>
          </div>

          <hr className="ov-divider" />

          <SectionTitle number={3} title="Eligibility" />
          <div className="ov-fields-row">
            <Field
              label="Assignment Type"
              value={eligibility.assignmentType}
              valueClass="ov-bold"
            />
            <Field
              label="Assigned To"
              value={eligibility.assignedTo}
              valueClass="ov-bold"
            />
            <Field
              label="Distribution Channel"
              value={eligibility.distributionChannel}
              valueClass="ov-bold"
            />
          </div>
          <div className="ov-fields-row">
            <Field
              label="Used By"
              value={eligibility.usedBy}
              valueClass="ov-bold"
            />
            <Field
              label="Assigned By"
              value={eligibility.assignedBy}
              valueClass="ov-bold"
            />
            <Field
              label="Assignment Date"
              value={eligibility.assignmentDate}
              valueClass="ov-bold"
            />
          </div>

          <hr className="ov-divider" />

          <SectionTitle number={4} title="Validity & Expiry" />
          <div className="ov-fields-row">
            <Field
              label="Start Date"
              value={validity.startDate}
              valueClass="ov-bold"
            />
            <Field
              label="End Date"
              value={validity.endDate}
              valueClass="ov-bold"
            />
            <Field
              label="Days Remaining"
              value={validity.daysRemaining}
              valueClass="ov-bold"
            />
            <Field
              label="Auto Expiry"
              value={
                <span className="ov-enabled-badge">
                  <CheckCircle2 size={14} /> {validity.autoExpiry}
                </span>
              }
            />
          </div>
          <div className="ov-fields-row">
            <Field
              label="Expiry Behavior"
              value={validity.expiryBehavior}
              valueClass="ov-bold"
            />
          </div>

          <hr className="ov-divider" />

          <SectionTitle number={5} title="Rules & Safeguards" />
          <div className="ov-fields-row">
            <Field
              label="Stack Behavior"
              value={rulesSafeguards.stackBehavior}
              valueClass="ov-bold"
            />
            <Field
              label="Partial Redemption"
              value={
                <span className="ov-enabled-badge">
                  <CheckCircle2 size={14} /> {rulesSafeguards.partialRedemption}
                </span>
              }
            />
            <Field
              label="Restore on Cancel"
              value={
                <span className="ov-enabled-badge">
                  <CheckCircle2 size={14} /> {rulesSafeguards.restoreOnCancel}
                </span>
              }
            />
            <Field
              label="Fraud Risk"
              value={rulesSafeguards.fraudRisk}
              valueClass="ov-bold"
            />
          </div>
          <div className="ov-fields-row">
            <Field
              label="Applicable Channels"
              value={rulesSafeguards.applicableChannels}
              valueClass="ov-bold"
            />
            <Field
              label="Usage Limit"
              value={rulesSafeguards.usageLimit}
              valueClass="ov-bold"
            />
            <Field
              label="Excluded Items"
              value={rulesSafeguards.excludedItems}
              valueClass="ov-bold"
            />
          </div>

          <hr className="ov-divider" />

          <SectionTitle number={6} title="Funding & Liability" />
          <div className="ov-fields-row">
            <Field
              label="Funding Source"
              value={fundingLiability.fundingSource}
              valueClass="ov-bold"
            />
            <Field
              label="Provider Share"
              value={fundingLiability.providerShare}
              valueClass="ov-bold"
            />
            <Field
              label="ESTBN Share"
              value={fundingLiability.estbnShare}
              valueClass="ov-bold"
            />
            <Field
              label="Total Committed Value"
              value={fundingLiability.totalCommittedValue}
              valueClass="ov-bold"
            />
          </div>
          <div className="ov-fields-row">
            <Field
              label="Total Discount Given"
              value={fundingLiability.totalDiscountGiven}
              valueClass="ov-bold"
            />
            <Field
              label="Remaining Commitment"
              value={fundingLiability.remainingCommitment}
              valueClass="ov-bold"
            />
          </div>
        </div>
      </div>

      {/* ================= RIGHT COLUMN ================= */}
      <div className="ov-right-col">
        <div className="ov-card">
          <div className="ov-side-header">
            <h3>Performance Snapshot</h3>
            <span className="ov-link">
              View Liability Report <ArrowUpRight size={14} />
            </span>
          </div>
          <div className="ov-side-list">
            {performanceSnapshot.map((item, i) => (
              <div className="ov-side-list-item" key={i}>
                <span className="ov-side-left">
                  <span className="ov-side-icon-circle">
                    <img src={item.icon} alt="" className="ov-side-icon-img" />
                  </span>
                  {item.label}
                </span>
                <span className="ov-side-value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="ov-card">
          <div className="ov-side-header">
            <h3>Quick Insights</h3>
            <span className="ov-link">
              View All <ArrowUpRight size={14} />
            </span>
          </div>
          <div className="ov-side-list">
            {quickInsights.map((item, i) => (
              <div className="ov-side-list-item" key={i}>
                <span className="ov-side-left">
                  <span className="ov-side-icon-circle">
                    <img src={item.icon} alt="" className="ov-side-icon-img" />
                  </span>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="ov-card">
          <div className="ov-side-header">
            <h3>Recent Activity</h3>
            <span className="ov-link">
              View all <ArrowUpRight size={14} />
            </span>
          </div>
          <div className="ov-timeline">
            {recentActivity.map((item, i) => (
              <div key={i} className="ov-timeline-item">
                <span className="ov-timeline-dot" />
                <div className="ov-timeline-content">
                  <div className="ov-timeline-row">
                    <span className="ov-timeline-title">{item.title}</span>
                    <span className="ov-timeline-by">{item.by}</span>
                  </div>
                  <span className="ov-timeline-date">{item.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
